module.exports = __webpack_public_path__ + "img/cleader2.df3ca3b0.png";